import { useState } from 'react';

// Every item is in the server-rendered HTML; the button only unfolds the ones already there, so
// crawlers and view-source see the whole list.
export default function ShowMoreList({
    id,
    items,
    open,
    itemKey,
    renderItem,
    nouns,
    listClassName,
    hiddenClassName,
    buttonClassName,
}) {
    const [expanded, setExpanded] = useState(false);
    const folded = Math.max(0, items.length - open);

    return (
        <>
            <ul id={id} className={listClassName}>
                {items.map((item, index) => (
                    <li
                        key={itemKey(item, index)}
                        className={
                            !expanded && index >= open
                                ? hiddenClassName
                                : undefined
                        }
                    >
                        {renderItem(item)}
                    </li>
                ))}
            </ul>
            {folded > 0 && (
                <button
                    type="button"
                    className={buttonClassName}
                    aria-controls={id}
                    aria-expanded={expanded}
                    onClick={() => setExpanded((value) => !value)}
                >
                    {expanded
                        ? `Show fewer ${nouns[1]}`
                        : `Show ${folded} more ${nouns[folded === 1 ? 0 : 1]}`}
                </button>
            )}
        </>
    );
}
